// extracted by mini-css-extract-plugin
module.exports = {"List":"AddLabels_List__106sV","Input":"AddLabels_Input__2wkB2","InputArea":"AddLabels_InputArea__3_BfQ","Checkbox":"AddLabels_Checkbox__22c0M"};